<template>
  <form :action="`/${locale}/account/foals-mares-registrations/${horseData.id}`" method="POST" enctype="multipart/form-data">
    <input type="hidden" name="_method" value="PUT" />
    <input type="hidden" name="_token" :value="token" />
    <div class="mb-3" v-if="horseData.horse_type !== 'Mare'">
      <fieldset>
        <select name="event_id" :id="'event_id-' + horseData.id" v-model="event_id" class="form-control"
                data-role="select" data-filter="false">
          <option value="null">{{
              'javascript.horse_registration.event_selection' | trans
            }}</option>
          <option v-for="(event, id) in events" :value="id" :key="id">{{ event }}</option>
        </select>
        <label class="form-control-placeholder" :for="'event_id' + horseData.id">{{
            'javascript.horse_registration.event' | trans
          }}</label>
      </fieldset>
    </div>

    <HorseInformation
      :horse="horseData"
      :mare-primes="marePrimes"
      :lot-breeds="lotBreeds"
      :lot-colors="lotColors"
      :sale-statuses="saleStatuses"
    />

    <div class="my-3 d-flex justify-content-end gap-s">
      <button class="btn btn-secondary m-0 small toggle-edit-panel" @click="discard" type="button">
        {{ 'javascript.horse_registration.discard' | trans }}
      </button>
      <button class="btn btn-primary m-0 small" type="submit">
        {{ 'javascript.horse_registration.confirm_changes' | trans }}
      </button>
    </div>
  </form>
</template>

<script>
import HorseInformation from './HorseInformation.vue'
export default {
  name: 'FoalRegistration',
  components: {HorseInformation },
  props: {
    horse: {
      type: Array | Object,
    },
    events: {
      type: Array | Object,
    },
    lotColors: {
      type: Array | Object,
    },
    lotBreeds: {
      type: Array | Object,
    },
    saleStatuses: {
      type: Array | Object,
    },
    currentEvent: {
      type: Array | Object,
    },
    eventId: {
      type: Number,
    },
    locale: {
      type: String,
      default: 'en',
    },
    marePrimes: {
      type: Array | Object,
      default() {
        return null
      },
    },
  },
  data() {
    return {
      event_id: '',
      horseData: {},
      token: null,
    }
  },
  created() {
    this.initializeForm()
    this.token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
  },
  methods: {
    initializeForm() {
      this.event_id = this.eventId ?? null
      this.horseData = this.horse
    },
    discard() {
      this.$emit('discard')
    },

  }
}
</script>
